/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react'
import { useTheme } from '../../../utils/ThemeColorContext'
import { AppStyles } from '../../../assets/styles/AppStyles'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
// import { conversionAPI } from '../../../redux/Actions/postMethods'

import CheckInformationWrapper from '../CheckInformationWrapper'
import ContentBankCard from '../../../components/cards/ContentBankCard'
import DefaultPage from '../DefaultPage'
import Image1 from '../../../assets/images/Image.png'
import {
  getApplications,
  getAccountsBasic,
  fetchApplicationStatus,
} from '../../../redux/Actions/getMethods'
import CheckingYourInfoCard from '../../../components/cards/CheckingYourInfoCard'
import { ActionTypes } from '../../../redux/Constants/actionTypes'
import AddAccount from '../../../components/cards/AddAccount'
import { useState } from 'react'

const SECOND = 1000
const MINUTE = 60 * SECOND

const POLL_SCHEDULE = [
  { until: 2 * MINUTE, delay: 5 * SECOND },
  { until: 5 * MINUTE, delay: 15 * SECOND },
  { until: 10 * MINUTE, delay: 30 * SECOND },
  { until: 30 * MINUTE, delay: MINUTE },
]
const LATE_POLL_DELAY = 5 * MINUTE
const STOP_POLLING = null
const PENDING_DIALOG_LIMIT = 2 * MINUTE
// automated_decision_pending may not be set yet straight after the page loads
const PENDING_FLAG_GRACE_PERIOD = 2 * MINUTE

const pollDelay = (elapsed) =>
  POLL_SCHEDULE.find(({ until }) => elapsed < until)?.delay ?? LATE_POLL_DELAY

const LoanReferred = () => {
  const dispatch = useDispatch()
  const { getApplication, loadingWholeScreen, loading } = useSelector(
    (state) => state.dataReducer,
  )
  const { token } = useSelector((state) => state.authReducer)
  const { color, isSmallScreen } = useTheme()
  const [accounts, setAccounts] = useState([])
  const [decisionPending, setDecisionPending] = useState()
  const [pendingDialogExpired, setPendingDialogExpired] = useState(false)
  const navigate = useNavigate()

  // useEffect(() => {
  //   if (token?.email) {
  //     localStorage.setItem(`journeyStep-${token?.email}`, '/loanreferred')
  //   }
  // }, [token?.email])

  // ==================== Polling for a decision  =======================//
  useEffect(() => {
    const loadedAt = Date.now()
    let unmounted = false
    let polling = false
    let seenPending = false
    let timerId
    const checkStatus = async () => {
      const status = await dispatch(fetchApplicationStatus())
      if (unmounted) {
        return STOP_POLLING
      }
      if (status?.status === 'CANNOT_APPLY' && status.declined) {
        navigate('/partner-offer')
        return STOP_POLLING
      }
      if (status?.status === 'APPROVED') {
        const applications = await dispatch(getApplications())
        if (unmounted || applications) {
          return STOP_POLLING
        }
        return pollDelay(Date.now() - loadedAt)
      }
      if (status) {
        setDecisionPending(status.automated_decision_pending === true)
      }
      if (status?.automated_decision_pending === true) {
        seenPending = true
      }
      const elapsed = Date.now() - loadedAt
      const automatedDecisionOver =
        seenPending || elapsed >= PENDING_FLAG_GRACE_PERIOD
      const awaitingUnderwriter =
        status?.status === 'REFERRED' &&
        status.automated_decision_pending === false &&
        automatedDecisionOver
      return awaitingUnderwriter ? LATE_POLL_DELAY : pollDelay(elapsed)
    }
    const poll = async () => {
      if (document.hidden) {
        return
      }
      polling = true
      const delay = await checkStatus()
      polling = false
      if (delay === STOP_POLLING) {
        return
      }
      timerId = setTimeout(poll, delay)
    }
    const pollWhenVisible = () => {
      if (document.hidden || polling) {
        return
      }
      clearTimeout(timerId)
      poll()
    }
    poll()
    document.addEventListener('visibilitychange', pollWhenVisible)
    return () => {
      unmounted = true
      clearTimeout(timerId)
      document.removeEventListener('visibilitychange', pollWhenVisible)
    }
  }, [])

  useEffect(() => {
    const timerId = setTimeout(
      () => setPendingDialogExpired(true),
      PENDING_DIALOG_LIMIT,
    )
    return () => clearTimeout(timerId)
  }, [])

  useEffect(() => {
    if (getApplication[0]?.status === 'DECLINED') {
      navigate('/partner-offer')
    } else if (getApplication[0]?.status === 'REFERRED') {
      // do nothing
    } else if (
      getApplication[0]?.status === 'APPROVED' &&
      getApplication[0]?.offer_type === 'UPDRAFT_CREDIT_INTEREST_ONLY'
    ) {
      navigate('/loanapproved')
    } else if (
      getApplication[0]?.status === 'APPROVED' &&
      getApplication[0]?.offer_type !== 'UPDRAFT_CREDIT_INTEREST_ONLY'
    ) {
      navigate('/loanapprovedfee')
    }
  }, [getApplication[0]?.id, getApplication[0]?.status])

  // ==================== Checking user status  =======================//
  useEffect(() => {
    if (!getApplication[0]?.id) {
      const temp = async () => {
        dispatch({ type: ActionTypes.LOADING_SUCCESS_WHOLE_SCREEN })
        const myID = await dispatch(getApplications())
        if (
          myID?.data[0]?.status === 'REFERRED' &&
          JSON.parse(localStorage.getItem(`bankConfirm-${token?.email}`))
        ) {
          dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
          // do nothing
        } else {
          dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
          navigate('/address-detail')
        }
      }
      temp()
    }
  }, [!getApplication[0]?.id])

  const goToVerifyIncome = () => {
    localStorage.removeItem(`bankConfirm-${token?.email}`)
    localStorage.removeItem(`add_accounts-${token?.email}`)
    localStorage.setItem(`add-another-bank-account-${token?.email}`, true)
    navigate('/verify-income')
  }

  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (loadingWholeScreen) {
      return
    }
    const timer = setTimeout(() => {
      setVisible(true)
    }, 0)
    return () => clearTimeout(timer)
  }, [loadingWholeScreen])

  useEffect(() => {
    const fetchBanks = async () => {
      const accounts = await dispatch(getAccountsBasic())
      const unexpiredAccounts = (accounts ? accounts : []).filter(account => (account?.days_to_renew ? account?.days_to_renew : 0) > 0)
      setAccounts(unexpiredAccounts ? unexpiredAccounts : [])
    }
    fetchBanks()
  }, [])

  return (
    <DefaultPage>
      {(loadingWholeScreen || loading || (decisionPending !== false && !pendingDialogExpired)) ? (
        <CheckingYourInfoCard />
      ) : (
        <div className="md:flex-col md:w-[456px] md:m-[auto] py-8 md:py-0 px-0 space-y-4 items-center">
          <div className="px-8">
            <CheckInformationWrapper img={Image1}>
              <div className="w-full space-y-8 md:space-y-10">
                <div className="flex flex-col items-center space-y-4 md:space-y-6 md:pb-[36px]">
                  <h1
                    style={
                      isSmallScreen
                        ? {
                            ...AppStyles.Title1,
                            color: color.Plum,
                          }
                        : {
                            ...AppStyles.LargeTitle2,
                            color: color.Plum,
                          }
                    }
                    className="text-center"
                  >
                    We’re{' '}
                    <span
                      style={
                        isSmallScreen
                          ? { ...AppStyles.Title1, color: color.Yellow }
                          : { ...AppStyles.LargeTitle2, color: color.Yellow }
                      }
                    >
                      Checking
                    </span>{' '}
                    Your Information Now!
                  </h1>
                  <p
                    style={
                      isSmallScreen
                        ? {
                            ...AppStyles.Body,
                            color: color.Grey,
                          }
                        : {
                            ...AppStyles.Body16,
                            color: color.Grey,
                          }
                    }
                    className="text-center"
                  >
                    Our underwriting team are looking at your application now,
                    they'll reach out to you with anything they require or a
                    decision via email.
                  </p>
                </div>
              </div>
            </CheckInformationWrapper>
          </div>
          <div
            style={{
              backgroundColor: color.White,
            }}
            className={` ${isSmallScreen ? 'px-0 py-8 space-y-6 md:w-[456px]' : 'px-0 py-8 rounded-3xl space-y-6 md:w-[456px]'}`}
          >
            <div 
              className="flex-col items-center justify-center md:w-[456px] md:m-[auto] px-8"
            >
              <div className=" space-y-6">
                <p
                  style={
                    isSmallScreen
                      ? {
                          ...AppStyles.Body,
                          color: color.Grey,
                        }
                      : {
                          ...AppStyles.Body16,
                          color: color.Grey,
                        }
                  }
                  className="text-center"
                >
                  We'll verify your income using the account(s) below
                </p>
                <div className=" grid grid-cols-1  gap-6  ">
                  {accounts?.map((bank, index) => (
                    <div key={index}>
                      <ContentBankCard
                        selectedBank={bank}
                        isSelected={false}
                      />
                    </div>
                  ))}
                  <div className={`fade-in ${visible ? 'visible' : ''}`}>
                    { visible && (
                      <AddAccount
                        onClick={() => {
                          if (visible) {
                            goToVerifyIncome()
                          }
                        }}
                        title="If you’ve been asked by our underwriters to connect another account, or haven't connected the accounts you receive your income into, you can do that here."
                        switched={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </DefaultPage>
  )
}
export default LoanReferred
